<template>
    <Background
        :backPath="'prevPage'">
        <div class="info-area">
            <div class="title">
                后台人员信息
            </div>
            <div class="info-paragraph">
                <div class="info-line">
                    <div class="info-label">姓名</div>
                    <div class="content-area">
                        <div class="info-content">{{ displayName }}</div>
                        <a-icon
                            v-on:click="popEditDialog('displayName')"
                            class="edit-button"
                            type="highlight" />
                    </div>
                </div>

                <div class="info-line">
                    <div class="info-label">后台人员ID</div>
                    <div class="info-content">{{ userId }}</div>
                </div>
            </div>
            <div class="info-paragraph">
                <div class="info-line">
                    <div class="info-label">登录手机号</div>
                    <div class="content-area">
                        <div class="info-content">{{ userName }}</div>
                        <a-icon
                            v-on:click="popEditDialog('userName')"
                            class="edit-button"
                            type="highlight"
                        />
                    </div>
                </div>
                <div class="info-line">
                    <div class="info-label">登录密码</div>
                    <div class="content-area">
                        <div class="info-content">******</div>
                        <a-icon
                            v-on:click="popEditDialog('password')"
                            class="edit-button"
                            type="highlight"
                        />
                    </div>
                </div>

            </div>

            <a-button
                v-on:click="deleteStaffer"
                class="delete-button"
                size="large"
                type="danger">
                删除后台人员
            </a-button>
        </div>

        <StafferEditDialog
            ref="dialog"
            :title="editInfoTitle"
            :hint="editInfoHint"
            :type="editInfoType"
            :inputType="editInfoInputType"
            :successMessage="editInfoSuccessMessage"
            :userId="editInfoUserId"
            :updateInfoCallback="updateInfo"
        />
    </Background>
</template>

<script>
 import Vue from 'vue';

 import Background from "./Background.vue"

 import StafferEditDialog from "./StafferEditDialog.vue"
 import Modal from "ant-design-vue/lib/modal";

 Vue.component(Modal.name, Modal);

 export default {
     name: 'StafferInfo',
     data() {
         return {
             userId: "",
             userName: "",
             role: 0,
             displayName: "",
             password: "",

             editInfoTitle: "",
             editInfoHint: "",
             editInfoType: "",
             editInfoInputType: "",
             editInfoSuccessMessage: "",
             editInfoUserId: 0
         }
     },
     props: {
     },
     components: {
         Background,
         StafferEditDialog
     },
     computed: {
     },
     mounted() {
         var info = JSON.parse(sessionStorage.getItem("clickStafferInfo"))

         this.userId = info.UserId
         this.userName = info.Username
         this.role = "" + info.Role
         this.displayName = info.DisplayName
     },
     methods: {
         popEditDialog(type) {
             if (type == "displayName") {
                 this.editInfoTitle = "编辑姓名",
                 this.editInfoHint = "请输入姓名"
                 this.editInfoSuccessMessage = "姓名更新成功"
                 this.editInfoInputType = "text"
             } else if (type == "userName") {
                 this.editInfoTitle = "编辑登录手机号",
                 this.editInfoHint = "请从手机号"
                 this.editInfoSuccessMessage = "手机号更新成功"
                 this.editInfoInputType = "text"
             } else if (type == "password") {
                 this.editInfoTitle = "编辑登录密码",
                 this.editInfoHint = "请输入登录密码"
                 this.editInfoSuccessMessage = "密码更新成功"
                 this.editInfoInputType = "password"
             }

             this.editInfoUserId = this.userId
             this.editInfoType = type
             this.$refs.dialog.show()
         },
         updateInfo(type, info) {
             if (type == "displayName") {
                 this.displayName = info
             } else if (type == "userName") {
                 this.userName = info
             } else if (type == "password") {
                 this.password = info
             }
         },
         deleteStaffer() {
             const modal = Modal.confirm();
             var that = this
             modal.update({
                 title: "删除后台人员",
                 content: '确定要删除此后台人员吗?',
                 centered: true,
                 okText: "确认",
                 cancelText: "取消",
                 onOk() {
                     const url = `${process.env.VUE_APP_API_SERVER}/user/${that.userId}`;
                     var accessToken = localStorage.getItem('accessToken')

                     fetch(url, {
                         method: 'DELETE',
                         headers: new Headers({
                             'Content-Type': 'application/json',
                             'Access-Token': accessToken
                         })
                     }
                     ).then(res => res.json()
                     ).catch(error => {
                         console.log("Error: ", error)
                     }).then(response => {
                         console.log(response)
                         that.$router.go(-1)
                     })
                 }
             })
         }
     },
 }
</script>

<style scoped>
 .info-area {
     width: 100%;
     height: 100%;
     padding-top: 80px;
     padding-left: 80px;
     padding-right: 80px;

     background-color: #FFF;

     position: relative;
 }

 .title {
     font-size: 24px;
     margin-left: 30px;
     margin-bottom: 20px;
     text-align: start;
 }

 .info-line {
     display: flex;
     flex-direction: column;
     justify-content: flex-start;
     width: 100%;
     border-right: 1px solid #EEE;
     padding-left: 30px;
 }

 .info-line:last-child {
     border-right: none;
 }

 .info-label {
     font-size: 18px;
     color: #333;
     width: 160px;
     text-align: start;
     margin-bottom: 10px;
     user-select: none;
 }

 .info-content {
     font-size: 16px;
     color: #999;
     text-align: start;
     height: 24px;
 }

 .info-paragraph {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: space-around;
     padding-top: 30px;
     padding-bottom: 30px;
     border-bottom: 1px solid #EFEFEF;
 }

 .content-area {
     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .edit-button {
     margin-left: 5px;
     margin-bottom: 2px;
     font-size: 16px;
     color: #333;
     cursor: pointer;
 }

 .edit-button:hover {
     color: #587FE0;
 }

 .delete-button {
     position: absolute;
     bottom: 40px;
 }

 .type-check-group {
     display: flex;
 }
</style>
